import React from 'react';
import Radium from 'radium';

import Dispatcher from 'service/Dispatcher';

import {A, Button} from 'views/AppElements';
import SessionStore from 'stores/SessionStore';

import { Formik } from 'formik';
import Yup from 'yup';
import {Input, SubmitButton, RGForm, TextArea, ComboBox, RadioButton} from 'views/FormElements';
import SelectedImagePreview from 'views/product/SelectedImagePreview';

import HttpService from 'service/HttpService';
import {ProductAction} from 'AppAction';

import AppConstants from 'AppConstants';
import AppUtil from 'AppUtil';

const USER_TYPE = AppConstants.USER_TYPE;

class AddNewImageForm extends React.Component {
	constructor(props) {
		super(props);
		this.onImageSelect = this.onImageSelect.bind(this);
		this.onUpload = this.onUpload.bind(this);
		this.state = {NEW_IMAGE: null, submitting: false}; 
		this.INPUT_FIELD_ID  = "addNewProductImage";
	}


	onImageSelect() {
		const imageFiles = document.getElementById(this.INPUT_FIELD_ID).files;

		if(imageFiles && imageFiles.length > 0)
			this.setState({NEW_IMAGE: imageFiles[0]});
		else
			this.setState({NEW_IMAGE: null});
	}

	onUpload() {
		var confirmRes = confirm("Are you sure you want upload this image?");

		if(confirmRes === false)
			return;
		
		const productId = this.props.product.id;

		this.setState({submitting: true});
		HttpService.addNewProductImage(productId, this.state.NEW_IMAGE, function(success) {
			if(success) {
				document.getElementById(this.INPUT_FIELD_ID).value = null;
				this.setState({NEW_IMAGE: null, submitting: false});
			} else {
				this.setState({submitting: false});
			}
			
		}.bind(this));
	}


	render() {
		if(this.props.product === null)
			return null;

		const uploadText = this.state.submitting? "Uploading...": "Upload";
		return <div>
				<hr />
				<h1>Add New Product Image</h1>
				<input id={this.INPUT_FIELD_ID} type="file" accept=".png, .jpg, .jpeg"  onChange={this.onImageSelect} />
				<br />

				<SelectedImagePreview style={{marginRight: '10px'}} id="newImagePreview" file={this.state.NEW_IMAGE} />

				{
				this.state.NEW_IMAGE && 
				<Button style={{width: 'fit-content'}} onClick={this.onUpload} disabled={this.state.submitting}>
					{uploadText}
				</Button>
			}
		</div>
	}
}


const PreviewImageEditForm = (props) => {
	if(props.product === null)
		return null;

	const previewImage = props.product.previewImage;

	
	return <div>
			<hr />
			<h1>Edit Preview Image</h1>
			<ImageEditForm product={props.product} 
					id={"updloadPreviewImageFile_"+props.product.id}
					productImage={previewImage} previewImage={true} />
		</div>
};

const ProductImageEditForm = (props) => {
	if(props.product === null)
		return null;

	const productImages = props.product.productImages;
	const editImages = productImages.map((url, i) => <ImageEditForm product={props.product} id={"updloadImageFile_"+i} productImage={url} key={"Product_Edit_"+i}/>);
	return <div>
			<hr />
			<h1>Edit Your Images</h1>
			{editImages}
		</div>
};



class ImageEditForm extends React.Component {

	constructor(props) {
		super(props);
		this.onImageSelect = this.onImageSelect.bind(this);
		this.onReplace = this.onReplace.bind(this);
		this.onRemove = this.onRemove.bind(this);
		this.state = {UPDATE_IMAGE: null, submitting: false}; 
	}

	onReplace() {
		const productId = this.props.product.id;

		this.setState({submitting: true});

		if(this.props.previewImage) {
			HttpService.updatePreviewImage(productId, this.state.UPDATE_IMAGE, function(success) {
				if(success) {
					document.getElementById(this.props.id+"_input").value = null;
					this.setState({UPDATE_IMAGE: null, submitting: false});
				} else {
					this.setState({submitting: false});
				}
				
			}.bind(this));
		} else {
			HttpService.updateProductImage(productId, this.props.productImage, this.state.UPDATE_IMAGE, function(success) {
				if(success) {
					document.getElementById(this.props.id+"_input").value = null;
					this.setState({UPDATE_IMAGE: null, submitting: false});
				} else {
					this.setState({submitting: false});
				}
				
			}.bind(this));
		}

		
	}

	onRemove() {
		var confirmRes = confirm("Are you sure you want delete this image?");

		if(confirmRes) {
			const productId = this.props.product.id;

			this.setState({submitting: true});
			HttpService.deleteProductImage(productId, this.props.productImage, function(success) {
				this.setState({submitting: false});
			}.bind(this));
		}
	}

	onImageSelect() {
		const imageFiles = document.getElementById(this.props.id+"_input").files;

		if(imageFiles && imageFiles.length > 0)
			this.setState({UPDATE_IMAGE: imageFiles[0]});
		else
			this.setState({UPDATE_IMAGE: null});
	}

	render() {
		const submitBtnText = this.state.submitting? "Replacing...": "Replace";
		const deleteBtnText = this.state.submitting? "Deleting...": "X";

		return <div className='flexRow' style={{margin: '20px 0', padding: '5px', width: 'fit-content', border: '1px dotted gray'}}>
					<img src={this.props.productImage} alt={this.props.product.title} className='miniImg' />
					
					<div className='flexColumn' style={{marginLeft: '10px'}}>
						<input id={this.props.id+"_input"} type="file" accept=".png, .jpg, .jpeg" onChange={this.onImageSelect} />
						<br />

						<SelectedImagePreview style={{marginRight: '10px'}} id={this.props.id} file={this.state.UPDATE_IMAGE} />
						<br />

						{
							this.state.UPDATE_IMAGE && 
							<Button style={{width: 'fit-content'}} onClick={this.onReplace} disabled={this.state.submitting}>
								{submitBtnText}
							</Button>
						}
					</div>

					{
						this.state.UPDATE_IMAGE === null && !this.props.previewImage && 
						<Button style={{height: 'fit-content', cursor: 'pointer'}} onClick={this.onRemove} disabled={this.state.submitting}>
							{deleteBtnText}
						</Button>
					}
				</div>
	}
}


class ProductEditForm extends React.Component {

	constructor(props) {
		super(props);

		this.validationScheme = this.validationScheme.bind(this);
		this.handleFormSubmission = this.handleFormSubmission.bind(this);

		this.PRODUCT_STATES = Object.keys(AppConstants.PRODUCT_STATE).map(function(k) {
			const optJson = {label: AppConstants.PRODUCT_STATE[k], value: k};

			return optJson;
		});

		this.DEFAULT_PRODUCT_TAGS = AppConstants.DEFAULT_PRODUCT_TAGS;
	}

	getInitialValues() {
		const product = this.props.product;
		
		return {
			title: product? product.title: '',
			description: product && product.description? product.description: '',
			productState: product? product.productState: '',
			price: product? product.price: '',
			aliasPrice: product? product.aliasPrice: '',
			margin: product? product.margin: '',
			priority: product && product.priority? product.priority : '',
			productMetaData: product && product.productMetaData? product.productMetaData: '',
			productTags: product && product.productTags? product.productTags: [],
			outsideRingRoadCharge: product && product.outsideRingRoadCharge? 'true': 'false',
			outofStock: product && product.outofStock? 'true': 'false',
			imgWidthPx: product && product.imgWidthPx? product.imgWidthPx: '',
			imgHeightPx: product && product.imgHeightPx? product.imgHeightPx: ''
		};
	}

	validationScheme() {
		const validation = {
			title: Yup.string().required("Enter a title that defines your image"),
		};

		const currentUser = this.props.currentUser;

		if(currentUser.userType === USER_TYPE.ADMIN) {
			validation['productState'] = Yup.string().required('Select a state');
			validation['price'] = Yup.number().required('Enter a price').min(500, "Enter price above 500.0");
			validation['margin'] = Yup.number().required('Enter a margin').min(100, "Enter margin above 100.0");
		}

		return Yup.object().shape(validation);
	}


	handleFormSubmission(value, {setSubmitting, resetForm}) {
		const productId = this.props.product.id;
		const isProductStateUpdated = value.productState !== this.props.product.productState;

		const isMarginUpdated = value.margin !== this.props.product.margin;

		HttpService.updateProductInfo(productId, value, function(success) {
			setSubmitting(false);

			if(success && isProductStateUpdated) {

				if(isProductStateUpdated) {
					Dispatcher.dispatch({
						type: ProductAction.UPDATE_PRODUCT_STATE
					});	
				}


				if(isMarginUpdated) {
					HttpService.getProductStat(productId);
				}
			}
		});
	}

	

	getProductTagOptions() {
		const product = this.props.product;

		if(product && product.productTags){
			return this.DEFAULT_PRODUCT_TAGS.concat(product.productTags.filter(function (item) {
					    										return this.DEFAULT_PRODUCT_TAGS.indexOf(item) < 0;
															}.bind(this)));
		}

		return this.DEFAULT_PRODUCT_TAGS;
	}

	render() {
		const currentUser = this.props.currentUser;
		const initialValues = this.getInitialValues();
		
		const productTagOptions = this.getProductTagOptions().map(function(v){
			return {'label': v.toUpperCase(), 'value': v.toLowerCase()}
		});

		const productType = this.props.product? this.props.product.productType: '';
		return <div>
				<h1>Edit Info</h1>

				<Formik enableReinitialize initialValues={initialValues} onSubmit={this.handleFormSubmission}
						validationSchema={this.validationScheme} 
						render={({values, setFieldValue, isSubmitting}) => {

					let submitBtn = 'Update';
		
					if(isSubmitting === true)
						submitBtn = <span>Updating <i className="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i></span>;

					return <RGForm>
						<Input label="Title: " name="title" type="text" />

						<TextArea placeholder={"Add a short info of your design (Optional)"}  name="description" rows="5" />

						<ComboBox name="productTags" value={values.productTags} 
											options={productTagOptions} placeholder="Select a Tag or Enter new" 
											multi={true}
											closeOnSelect={false} 
											creatable={true} />
											
						{
							currentUser.userType === USER_TYPE.ADMIN &&
							<div>
								<Input label="Price: " name="price" type="number" />
								
								<Input label="Margin: " name="margin" type="number" />

								<ComboBox name="productState" value={values.productState} 
											options={this.PRODUCT_STATES} placeholder="Select State" clearable={false}/>

								<Input label="Priority: " name="priority" type="number" />

								<Input label="MetaData: " name="productMetaData" type="text" />

								<h2><b>Others</b></h2>
								<Input label="Alias Price: " name="aliasPrice" type="number" />

								<h4><b>Ringroad Charge</b></h4>
								<div className='flexRow'>
									<RadioButton style={{flexGrow: '1'}} name="outsideRingRoadCharge" value='true'
												label="Apply Outside RingRoad Charge" 
												checked={values.outsideRingRoadCharge === 'true'} />
									
									<RadioButton style={{flexGrow: '1'}} name="outsideRingRoadCharge" value='false' 
												label="No Outside RingRoad Charge" 
												checked={values.outsideRingRoadCharge !== 'true'} />
								</div>
								<hr />

								<h4><b>Stock Info</b></h4>
								<div className='flexRow'>
									<RadioButton style={{flexGrow: '1'}} name="outofStock" value='true'
												label="Out of Stock" 
												checked={values.outofStock === 'true'} />
									
									<RadioButton style={{flexGrow: '1'}} name="outofStock" value='false' 
												label="In Stock" 
												checked={values.outofStock !== 'true'} />
								</div>


								{
									productType === AppConstants.PRODUCT_TYPES['PHOTO_FRAME'].val &&
									<React.Fragment>
										<h4><b>Image Dimension</b></h4>
										<div className='flexRow'>
											<div style={{marginRight: '10px'}}>
												<Input label="Img Width in Pixel: " name="imgWidthPx" type="number" />
											</div>
											<Input label="Img Height in Pixel: " name="imgHeightPx" type="number" />
										</div>	
									</React.Fragment>
									
								}
								
							</div>
						}

						
						
						<SubmitButton color="primary" disabled={isSubmitting || this.props.product === null}>{submitBtn}</SubmitButton>
					</RGForm>				
				}} />
			</div>;	
	}
	
}

class ProductSettings extends React.Component {

	showLogin() {
		Dispatcher.dispatchAlertWithAction(AppConstants.LOGIN_TO_CONTINUE_MSG, "WARN");
	}

	componentDidMount() {
		AppUtil.scrollToHashTagIfAny();
	}

	render() {
		const currentSession = SessionStore.getCurrentSession();
		
		if(currentSession === null)
			return <h2 style={{textAlign: "center"}}>Click <A href="#" onClick={this.showLogin.bind(this)}>here</A> to login.</h2>;

		const currentUser = currentSession.user;
		if(currentUser.userType === USER_TYPE.REGULAR)
			return <h1 style={{textAlign: "center"}}>You seem to have lost. Go <A href="/">here</A> to find what you are looking for.</h1>

		const product = this.props.product;

		const productUrl = product? AppUtil.getProductURL(product): "#";

		return <div style={{width: "50%", margin: "10px auto", '@media (max-width: 770px)': {width: 'auto'}}} id="productSettingsPage">
					<h3><A href={productUrl}>Go Back To Product</A></h3>
					<ProductEditForm product={product} currentUser={currentUser} />
					
					{
						currentUser.userType === USER_TYPE.ADMIN &&
						<PreviewImageEditForm product={product} />
					}

					<ProductImageEditForm product={product} />

					<AddNewImageForm product={product} />
			</div>
	}
}


export default Radium(ProductSettings);




// WEBPACK FOOTER //
// ./src/views/product/ProductSettings.js